<template>
  <md-snackbar :md-position="position" :md-duration="isInfinity ? Infinity : duration" :md-active.sync="showSnackbar" md-persistent>
    <span>{{message}}</span>
    <md-button class="md-primary" style="color:#fea49f" @click="reportNpsScoreOf(0)">0</md-button>
    <md-button class="md-primary" style="color:#fea49f" @click="reportNpsScoreOf(1)">1</md-button>
    <md-button class="md-primary" style="color:#fea49f" @click="reportNpsScoreOf(2)">2</md-button>
    <md-button class="md-primary" style="color:#fea49f" @click="reportNpsScoreOf(3)">3</md-button>
    <md-button class="md-primary" style="color:#fea49f" @click="reportNpsScoreOf(4)">4</md-button>
    <md-button class="md-primary" style="color:#fea49f" @click="reportNpsScoreOf(5)">5</md-button>
    <md-button class="md-primary" style="color:#fea49f" @click="reportNpsScoreOf(6)">6</md-button>
    <md-button class="md-primary" style="color:#fea49f" @click="reportNpsScoreOf(7)">7</md-button>
    <md-button class="md-primary" style="color:#fea49f" @click="reportNpsScoreOf(8)">8</md-button>
    <md-button class="md-primary" style="color:#fea49f" @click="reportNpsScoreOf(9)">9</md-button>
    <md-button class="md-primary" style="color:#fea49f" @click="reportNpsScoreOf(10)">10</md-button>

  </md-snackbar>
</template>

<script>
  import { reportNpsScore } from '../platform/analytics/services/usageStatsService.js'
  export default {
    props: {
      message:{
        type: String,
        required: true
      },
      duration:{
        type: Number,
        required: true
      },
      showSnackbar:{
        type: Boolean,
        required: true
      },
      position:{
        type: String,
        required: true
      },
      isInfinity:{
        type: Boolean,
        required: true
      }
    },
    data() {
      return {
      }
    },
    computed: {
    },
    created(){
    },
    methods: {
      closeNps(){
        this.$store.commit("SET_ASK_NPS", false)
      },
      reportNpsScoreOf(score){
        this.closeNps()
        // this.showSnackbar = false
        reportNpsScore(score)
      }
    }
  }
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/npsSnackbar.vue